import * as React from 'react';
import {classes} from './pagination.st.css';
import s from '../ProductList.scss';
import {Pagination as PaginationUI} from '@wix/wix-ui-tpa/cssVars';
import {PaginationTypeName} from '../../../../types/galleryTypes';

export const enum PaginationDataHooks {
  Root = 'product-list-pagination',
  TpaPagination = 'product-list-tpa-pagination',
}

export interface PaginationProps {
  handlePagination(page: number): void;
  currentPage: number;
  totalPages: number;
  paginationMode: PaginationTypeName;
  showFirstLastNavButtons: boolean;
  linkForAllPages?: string[];
}

export const Pagination: React.FunctionComponent<PaginationProps> = (props) => {
  const {currentPage, paginationMode, showFirstLastNavButtons, totalPages, handlePagination, linkForAllPages} = props;

  const getHref = (i) => {
    if (!linkForAllPages?.length) {
      return undefined;
    }
    return linkForAllPages[i - 1];
  };

  return (
    <div data-hook={PaginationDataHooks.Root} className={s.pagination}>
      <PaginationUI
        className={classes.root}
        currentPage={currentPage}
        data-hook={PaginationDataHooks.TpaPagination}
        onChange={({event, page}) => {
          event.stopPropagation();
          event.preventDefault();
          handlePagination(page);
        }}
        paginationMode={paginationMode}
        showFirstLastNavButtons={showFirstLastNavButtons}
        showFirstPage
        showLastPage
        totalPages={totalPages}
        pageUrl={getHref}
      />
    </div>
  );
};
